import type { BookingStatus } from '../types/booking.types.js';

export type ReservationStatus = BookingStatus | 'NO_SHOW';
type ReservationSlot = {
  status: BookingStatus;
  attendanceOverride?: boolean | null;
  slot: { endTime: string | Date };
  accessCode?: {
    validUntil?: string | Date;
    pinUsedAt?: string | Date | null;
    remoteOpenedAt?: string | Date | null;
    status?: string;
  } | null;
};

/** Attendance is derived so delayed access logs automatically correct a no-show. */
export function reservationStatus(items: ReservationSlot[], now = new Date()): ReservationStatus {
  const confirmed = items.filter((b) => ['PAID', 'ACTIVE', 'COMPLETED'].includes(b.status));
  const representative =
    items.find((b) => b.status === 'ACTIVE') ??
    items.find((b) => ['PENDING', 'PAID'].includes(b.status)) ??
    items[0];
  if (!confirmed.length) return representative?.status ?? 'PENDING';
  // Explicit staff corrections take precedence over automatic log classification.
  if (confirmed.every((b) => b.attendanceOverride === false)) return 'NO_SHOW';
  if (confirmed.every((b) => b.attendanceOverride === true)) return 'COMPLETED';
  const ended = confirmed.every((b) => new Date(b.slot.endTime).getTime() <= now.getTime());
  if (!ended) return representative?.status ?? 'PENDING';
  const entered = confirmed.some(
    (b) =>
      b.accessCode?.pinUsedAt || b.accessCode?.remoteOpenedAt || b.accessCode?.status === 'USED',
  );
  if (entered) return 'COMPLETED';
  const expired = confirmed.every(
    (b) => new Date(b.accessCode?.validUntil ?? b.slot.endTime).getTime() <= now.getTime(),
  );
  return expired ? 'NO_SHOW' : 'ACTIVE';
}
